import React, { useState } from 'react';
import { VendorHeader } from './VendorHeader';
import { VendorSidebar } from './VendorSidebar';
import { VendorDashboard } from './VendorDashboard';
import { InvoiceList } from './InvoiceList';
import { InvoiceDetail } from './InvoiceDetail';
import { UploadInvoice } from './UploadInvoice';
import { VendorProfile } from './VendorProfile';
import { VendorDocuments } from './VendorDocuments';
import { DocumentDetail } from './DocumentDetail';
import { ESGProfile } from './ESGProfile';
import { UploadCreditNote } from './UploadCreditNote';
import { CommunicationCenter } from './CommunicationCenter';
import { ReminderSettings } from './ReminderSettings';
import { ESignatureCenter } from './ESignatureCenter';
export function VendorPortal({
  vendor,
  onLogout
}) {
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  // State for communication threads
  const [messageThreads, setMessageThreads] = useState([{
    id: 1,
    subject: 'Invoice #INV-2023-0042 Payment Status',
    participants: ['Acme Corp', 'Your Company'],
    lastMessageDate: '2023-10-25T14:30:00',
    unread: true,
    priority: 'high',
    messages: [{
      id: 101,
      sender: 'Acme Corp',
      senderRole: 'Client',
      timestamp: '2023-10-25T14:30:00',
      content: "We're reviewing the invoice you submitted last week. Could you please provide more details on the line items for the consulting services?",
      read: true,
      readTimestamp: '2023-10-25T15:45:00'
    }, {
      id: 102,
      sender: 'Your Company',
      senderRole: 'Vendor',
      timestamp: '2023-10-25T16:10:00',
      content: 'Certainly! The consulting services include 20 hours of technical consultation at $150/hr and 10 hours of project management at $125/hr. Would you like me to provide a more detailed breakdown?',
      read: true,
      readTimestamp: '2023-10-25T16:45:00'
    }, {
      id: 103,
      sender: 'Acme Corp',
      senderRole: 'Client',
      timestamp: '2023-10-26T09:15:00',
      content: 'Yes, please. Could you specify which projects these hours were allocated to? We need to assign them to the correct cost centers.',
      read: false
    }],
    auditTrail: [{
      action: 'Thread created',
      timestamp: '2023-10-25T14:30:00',
      user: 'Acme Corp'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-25T14:30:00',
      user: 'Acme Corp'
    }, {
      action: 'Message read',
      timestamp: '2023-10-25T15:45:00',
      user: 'Your Company'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-25T16:10:00',
      user: 'Your Company'
    }, {
      action: 'Message read',
      timestamp: '2023-10-25T16:45:00',
      user: 'Acme Corp'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-26T09:15:00',
      user: 'Acme Corp'
    }]
  }, {
    id: 2,
    subject: 'Updated Terms of Service Agreement',
    participants: ['Acme Corp', 'Your Company'],
    lastMessageDate: '2023-10-24T11:20:00',
    unread: false,
    priority: 'medium',
    messages: [{
      id: 201,
      sender: 'Acme Corp',
      senderRole: 'Client',
      timestamp: '2023-10-24T11:20:00',
      content: "We've updated our terms of service. Please review and acknowledge the changes by the end of the week.",
      read: true,
      readTimestamp: '2023-10-24T13:05:00',
      attachment: {
        name: 'Updated_TOS_2023.pdf',
        size: '1.2 MB'
      }
    }, {
      id: 202,
      sender: 'Your Company',
      senderRole: 'Vendor',
      timestamp: '2023-10-24T15:40:00',
      content: "I've reviewed the changes. The new liability clauses look reasonable. I'll have our legal team provide formal acknowledgment by Friday.",
      read: true,
      readTimestamp: '2023-10-24T16:30:00'
    }],
    auditTrail: [{
      action: 'Thread created',
      timestamp: '2023-10-24T11:20:00',
      user: 'Acme Corp'
    }, {
      action: 'Message sent with attachment',
      timestamp: '2023-10-24T11:20:00',
      user: 'Acme Corp'
    }, {
      action: 'Message read',
      timestamp: '2023-10-24T13:05:00',
      user: 'Your Company'
    }, {
      action: 'Attachment downloaded',
      timestamp: '2023-10-24T13:10:00',
      user: 'Your Company'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-24T15:40:00',
      user: 'Your Company'
    }, {
      action: 'Message read',
      timestamp: '2023-10-24T16:30:00',
      user: 'Acme Corp'
    }]
  }, {
    id: 3,
    subject: 'Upcoming Maintenance Window',
    participants: ['Acme Corp', 'Your Company'],
    lastMessageDate: '2023-10-20T09:45:00',
    unread: false,
    priority: 'low',
    messages: [{
      id: 301,
      sender: 'Acme Corp',
      senderRole: 'Client',
      timestamp: '2023-10-20T09:45:00',
      content: "We'll be performing system maintenance this weekend. The vendor portal will be unavailable from Saturday 10 PM to Sunday 2 AM Eastern Time.",
      read: true,
      readTimestamp: '2023-10-20T10:30:00'
    }, {
      id: 302,
      sender: 'Your Company',
      senderRole: 'Vendor',
      timestamp: '2023-10-20T11:15:00',
      content: 'Thanks for letting me know. That timeframe works fine for us.',
      read: true,
      readTimestamp: '2023-10-20T13:45:00'
    }],
    auditTrail: [{
      action: 'Thread created',
      timestamp: '2023-10-20T09:45:00',
      user: 'Acme Corp'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-20T09:45:00',
      user: 'Acme Corp'
    }, {
      action: 'Message read',
      timestamp: '2023-10-20T10:30:00',
      user: 'Your Company'
    }, {
      action: 'Message sent',
      timestamp: '2023-10-20T11:15:00',
      user: 'Your Company'
    }, {
      action: 'Message read',
      timestamp: '2023-10-20T13:45:00',
      user: 'Acme Corp'
    }]
  }]);
  // Function to handle adding a comment to an invoice and creating/updating a communication thread
  const handleAddInvoiceComment = (invoice, commentText) => {
    // 1. Add comment to the invoice
    const updatedInvoice = {
      ...invoice,
      comments: [...(invoice.comments || []), {
        id: (invoice.comments?.length || 0) + 1,
        user: 'Vendor',
        date: new Date().toLocaleString(),
        text: commentText
      }]
    };
    // Update the selected invoice
    setSelectedInvoice(updatedInvoice);
    // 2. Create or update a communication thread for this invoice
    const threadSubject = `Invoice #${invoice.id} Discussion`;
    const existingThreadIndex = messageThreads.findIndex(thread => thread.subject === threadSubject);
    const timestamp = new Date().toISOString();
    const newMessage = {
      id: Date.now(),
      sender: 'Your Company',
      senderRole: 'Vendor',
      timestamp,
      content: commentText,
      read: false
    };
    const auditEntry = {
      action: 'Message sent from Invoice Comments',
      timestamp,
      user: 'Your Company'
    };
    if (existingThreadIndex >= 0) {
      // Update existing thread
      const updatedThreads = [...messageThreads];
      updatedThreads[existingThreadIndex] = {
        ...updatedThreads[existingThreadIndex],
        lastMessageDate: timestamp,
        unread: false,
        messages: [...updatedThreads[existingThreadIndex].messages, newMessage],
        auditTrail: [...updatedThreads[existingThreadIndex].auditTrail, auditEntry]
      };
      setMessageThreads(updatedThreads);
    } else {
      // Create new thread
      const newThread = {
        id: Date.now(),
        subject: threadSubject,
        participants: ['Your Company', 'Acme Corp'],
        lastMessageDate: timestamp,
        unread: false,
        priority: 'medium',
        messages: [newMessage],
        auditTrail: [{
          action: 'Thread created from Invoice Comments',
          timestamp,
          user: 'Your Company'
        }, auditEntry]
      };
      setMessageThreads([newThread, ...messageThreads]);
    }
    return updatedInvoice;
  };
  // Render the appropriate view based on currentView state
  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <VendorDashboard vendor={vendor} onViewInvoice={invoice => {
          setSelectedInvoice(invoice);
          setCurrentView('invoice-detail');
        }} data-id="element-1208" />;
      case 'invoices':
        return <InvoiceList vendor={vendor} onViewInvoice={invoice => {
          setSelectedInvoice(invoice);
          setCurrentView('invoice-detail');
        }} data-id="element-1209" />;
      case 'invoice-detail':
        return <InvoiceDetail invoice={selectedInvoice} onBack={() => setCurrentView('invoices')} onAddComment={handleAddInvoiceComment} data-id="element-1210" />;
      case 'documents':
        return <VendorDocuments vendor={vendor} onViewDocument={document => {
          setSelectedDocument(document);
          setCurrentView('document-detail');
        }} data-id="element-1211" />;
      case 'document-detail':
        return <DocumentDetail document={selectedDocument} onBack={() => setCurrentView('documents')} data-id="element-1212" />;
      case 'esg-profile':
        return <ESGProfile vendor={vendor} data-id="element-1213" />;
      case 'upload-invoice':
        return <UploadInvoice vendor={vendor} onSuccess={() => setCurrentView('invoices')} data-id="element-1214" />;
      case 'upload-credit-note':
        return <UploadCreditNote vendor={vendor} onSuccess={() => setCurrentView('invoices')} data-id="element-1215" />;
      case 'communications':
        return <CommunicationCenter vendor={vendor} messageThreads={messageThreads} setMessageThreads={setMessageThreads} data-id="element-1216" />;
      case 'reminders':
        return <ReminderSettings vendor={vendor} data-id="element-1217" />;
      case 'esignature':
        return <ESignatureCenter vendor={vendor} data-id="element-1218" />;
      case 'profile':
        return <VendorProfile vendor={vendor} data-id="element-1219" />;
      default:
        return <VendorDashboard vendor={vendor} data-id="element-1220" />;
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1221">
      <VendorHeader vendor={vendor} onLogout={onLogout} data-id="element-1222" />
      <div className="flex" data-id="element-1223">
        <VendorSidebar currentView={currentView} setCurrentView={setCurrentView} data-id="element-1224" />
        <main className="flex-1 p-6" data-id="element-1225">{renderView()}</main>
      </div>
    </div>;
}